export const AlertStyles = {
  attentionCard: {
    display: "grid",
    gridTemplateColumns: "1fr 15fr 1fr",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    borderRadius: "10px",
    padding: "30px",
    border: "1px solid #C9E1EC",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    "@media only screen and (max-width: 768px)": {
      gridTemplateColumns: "0.5fr 10fr",
      gridTemplateRows: "1fr 0.5fr",
      gridTemplateAreas: `"image text"
                                  "button button"`,
      img: {
        gridArea: "image",
      },
    },
  },
  attentionCardItem: {
    display: "grid",
    "@media only screen and (max-width: 768px)": {
      gridArea: "text",
    },
  },
  attentionCardItemHeadingStyle: {
    color: "#1D252B",
    fontSize: "18px",
    fontFamily: "Noto Sans",
    fontStyle: "normal",
    fontWeight: "400",
    textOverflow: "ellipsis",
    "@media (max-width:599px)": {
      fontSize: "16px",
    },
  },
  attentionCardItemContentStyle: {
    color: "#1D252B",
    fontSize: "18px",
    fontFamily: "Noto Sans",
    fontWeight: "300",
    "@media(max-width:599px)": {
      fontSize: "14px",
      color: "#1D252B",
      fontFamily: '"Noto Sans"',
      fontWeight: 300,
    },
    "@media (min-width: 1025px) and (max-width: 1366px)": {
      maxWidth: "900px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  attentionCardButtonContainer: {
    "@media only screen and (max-width: 768px)": {
      gridArea: "button",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  attentionCardButton: {
    width: "max-content",
  },
};
